import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import './Darshan.css';
import { useLanguage } from '../context/LanguageContext';

const useScrollReveal = (selector, options = {}) => {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in-view'); });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px', ...options });
    document.querySelectorAll(selector).forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, [selector]);
};

const Darshan = () => {
    const { t } = useLanguage();

    useScrollReveal('.reveal');

    return (
        <motion.div 
            className="darshan-page"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
        >
            {/* Cinematic Hero */}
            <div className="darshan-hero">
                <div className="darshan-hero-bg" />
                <div className="darshan-hero-overlay" />
                <div className="darshan-hero-rays" aria-hidden="true">
                    {[1, 2, 3, 4, 5].map(i => <span key={i} className={`hero-ray hero-ray-${i}`} />)}
                </div>
                <div className="darshan-hero-content">
                    <span className="page-hero-pill">{t('home.facts.darshanTitle')}</span>
                    <h1 className="page-hero-title">{t('home.facts.darshanTitle')}</h1>
                    <div className="page-hero-divider">
                        <span className="phd-line" /><span className="phd-diamond">◆</span><span className="phd-line" />
                    </div>
                </div>
                <div className="page-hero-bottom-line" />
            </div>

            {/* Sticky Timing Banner */}
            <div className="sticky-timing-banner">
                <p className="timing-text-marathi">
                    दर्शन वेळ: सकाळी: ५:०० - ११:०० | संध्याकाळी: ४:०० - ९:००
                </p>
            </div>

            {/* Main Content Area */}
            <div className="deity-idol-container reveal">
                <img
                    src="/Assets/darshan_full.png"
                    alt="Shri Nath Mahaskoba Maharaj"
                    className="deity-idol-img"
                />

                {/* Visual Enhancements */}
                <div className="sacred-overlay"></div>

                <div className="puja-setup-overlay">
                    {/* These could be subtle animated elements or just part of the image */}
                    <div className="glow-effect"></div>
                </div>
            </div>
        </motion.div>
    );
};

export default Darshan;
